import Container from '@/components/Container';
import Lead from '@/components/Lead';
import SubHeading from '@/components/SubHeading';
import Card, { CardTitle, CardText } from '@/components/Card';
import Text from '@/components/Text';
import Image from '@/components/Image';
import Brand from '@/view/Brand';
import WorldMapCertifications from '@/domain/Testimonials/WorldMapCertifications';

export default function AboutUs() {
  return (
    <div className="bg-white overflow-hidden">
      <div className="relative overflow-hidden min-h-screen bg-gradient-to-t from-white via-green-100 to-white pb-10 lg:pb-20">
        <Container className="relative z-20">
          <div className="py-10 lg:pt-20 lg:pb-32 flex flex-col items-center lg:max-w-screen-lg lg:mx-auto">
            <div className="flex flex-col items-center md:text-center lg:px-10 space-y-10 lg:space-y-12">
              <div className="flex flex-col space-y-2">
                <SubHeading heading="Nosotros" />
                <h1 className="text-4xl xl:text-5xl tracking-tight font-bold">
                  Entidad certificadora por excelencia preferida por hispanohablantes
                </h1>
              </div>
              <Lead className="lg:px-32 xl:leading-relaxed xl:font-normal xl:text-xl text-gray-700" muted={false}>
                Mediante la formación integral de su equipo, la evaluación y la certificación
                de sus habilidades, propiciamos la entrega periódica y continua de valor de
                sus productos y servicios.
              </Lead>
            </div>
          </div>
        </Container>
        <div className="relative z-10 pb-10">
          <Container maxWidth="max-w-screen-lg">
            <div className="relative aspect-w-16 aspect-h-9 md:transform md:-skew-y-6 overflow-hidden rounded-xl shadow-xl xl:shadow-2xl">
              <div className="absolute inset-0 scale-125 bg-center bg-no-repeat bg-cover transform md:skew-y-6" style={{ backgroundImage: 'url(https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy/v1610683320/nosotros/acerca-de-aibes_kxyiy9.jpg)' }} />
            </div>
          </Container>
        </div>
        <div className="absolute z-0 w-full inset-0 pointer-events-none overflow-hidden flex-col items-start hidden md:flex">
          <div className="transform -skew-y-6 absolute top-0 left-0 w-2/6 xl:w-3/6 mt-20 lg:mt-96 xl:-ml-20">
            <div className="h-40 w-2/4 bg-gradient-to-r from-green-200 to-transparent" />
            <div className="h-40 w-2/3 bg-gradient-to-r from-green-300 to-transparent" />
            <div className="h-40 w-5/6 bg-gradient-to-r from-green-400 to-transparent" />
          </div>
          <div className="transform -skew-y-6 absolute bottom-0 right-0 w-2/6 xl:w-3/6 mt-20 lg:mt-96 xl:-mr-20 flex flex-col items-end">
            <div className="h-40 w-5/6 bg-gradient-to-l from-green-200 to-transparent" />
            <div className="h-40 w-2/3 bg-gradient-to-l from-green-300 to-transparent" />
            <div className="h-40 w-2/4 bg-gradient-to-l from-green-400 to-transparent" />
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-t from-green-100 to-white">
        <Container maxWidth="max-w-screen-lg" className="pb-10 lg:pb-20 xl:pt-16">
          <div className="lg:text-center">
            <h2 className="text-2xl lg:text-4xl font-semibold tracking-tight mb-4 lg:mb-8 lg:px-10">
              Con formación, entrenamiento y consultoría, ayudamos a personas y a
              empresas a entregar mayor valor en sus productos y servicios
            </h2>
            <Text muted className="font-normal text-lg lg:text-xl text-cool-gray-700">
              Nuestras soluciones de acompañamiento, capacitación y entrenamiento permiten
              a profesionales, organizaciones e instituciones, lograr la adopción de una cultura ágil.
            </Text>
          </div>
        </Container>
        <WorldMapCertifications />
      </div>
      <div className="py-10 lg:py-20 relative z-10 hidden md:block">
        <div className="absolute left-0 right-0 top-0 flex justify-center h-40 -mt-20">
          <div className="w-40 h-40 rounded-full shadow-xl relative">
            <div className="w-32 h-32 absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
              <span className="animate-ping-slow inline-flex h-32 w-32 rounded-full border-2 border-green-500 opacity-75 absolute z-0" />
              <span className="animate-ping-slow-offset inline-flex h-32 w-32 rounded-full border-2 border-green-500 opacity-75 absolute z-0" />
              <span className="animate-ping-slow-offset-2x inline-flex h-32 w-32 rounded-full border-2 border-green-500 opacity-75 absolute z-0" />
            </div>
            <div className="w-40 h-40 rounded-full bg-white relative flex items-center justify-center z-20">
              <Brand hideName noLink logoSize="lg" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white space-y-10 py-10 lg:py-20 relative">
        <Container maxWidth="max-w-screen-lg" className="relative z-10">
          <div className="text-left md:text-center">
            <SubHeading heading="Nuestra misión" />
            <div className="space-y-4 lg:space-y-6">
              <h3 className="text-3xl lg:text-4xl font-bold tracking-tight">
                Certificar profesionales de excelencia
              </h3>
              <Text muted className="font-normal text-lg text-cool-gray-700 leading-7 mx-auto max-w-screen-md">
                Formar, entrenar, acompañar y certificar a profesionales; validando
                sus habilidades y competencias a través de certificaciones reconocidas
                internacionalmente.
              </Text>
            </div>
          </div>
        </Container>
      </div>
      <div className="bg-gradient-to-b from-gray-100 to-white space-y-10 lg:space-y-20 py-10 lg:py-20 relative">
        <Container maxWidth="max-w-screen-lg" className="relative z-10">
          <div className="text-left md:text-center">
            <SubHeading heading="Nuestra visión" />
            <div className="space-y-4 lg:space-y-6">
              <h3 className="text-3xl lg:text-4xl font-bold tracking-tight">
                Entidad certificadora de excelencia preferida por hispanohablantes
              </h3>
              <Text muted className="font-normal text-lg text-cool-gray-700 leading-7 mx-auto max-w-screen-md">
                Ser reconocidos internacionalmente como la entidad certificadora de excelencia
                por nuestros métodos innovadores, soluciones, productos y servicios.
              </Text>
            </div>
          </div>
        </Container>
        <Container maxWidth="max-w-screen-lg">
          <ul className="list-none space-y-2 lg:space-y-0 lg:gap-10 grid grid-cols-1 lg:grid-cols-3 text-left space-y-10 md:space-y-0">
            <li className="flex flex-col space-y-4">
              <svg className="w-12 h-12" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 100 100" fill="none">
                <rect className="fill-current text-green-200" width="100" height="100" rx="25" ry="25" />
                <path className="fill-current text-white" d="M62 75.02586V68c0-8.21457 12-14.54 12-26.6153C74 27.9174 63.25483 17 50 17S26 27.9174 26 41.3847C26 53.4321 38.00582 59.83342 38 68c-.00106 1.47941 0 7.1122 0 7.1122l24-.08634z" />
                <path className="fill-current text-green-500" d="M62 70v6c0 4.08985-2.79726 7-6 7H44c-3.21336 0-6-2.91745-6-7v-6h24zm-2.21157-27.88626c.49395.99486.09352 2.2046-.8944 2.70203l-6.97411 3.51158v14.75148C51.91992 64.13086 51.06034 65 50 65c-1.06773 0-1.91992-.86014-1.91992-1.92117V48.32735l-6.97412-3.51158c-.98791-.49743-1.38834-1.70717-.89439-2.70203.49396-.99486 1.69525-1.3981 2.68317-.90068L50 44.79067l7.10526-3.5776c.98792-.49744 2.1892-.0942 2.68317.90067z" />
              </svg>
              <div className="text-lg">
                Por nuestros&nbsp;
                <b className="font-semibold">métodos innovadores</b>
                , soluciones, productos y servicios.
              </div>
            </li>
            <li className="flex flex-col space-y-4">
              <svg className="w-12 h-12" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 100 100" fill="none">
                <rect className="fill-current text-green-200" width="100" height="100" rx="25" ry="25" />
                <path className="fill-current text-white" d="M50 52c15.5828 0 23.8992 7.6071 24.9491 16.8213l.0509.5166v4.0966c0 1.1312-1.0175 2.0483-2.2727 2.0483H27.2727c-1.2552 0-2.2727-.917-2.2727-2.0483v-4.0966l.0509-.5166C26.1008 59.607 34.4172 52 50 52z" fillRule="nonzero" />
                <path className="fill-current text-green-400" d="M50 20c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14z" />
              </svg>
              <div className="text-lg">
                Por la&nbsp;
                <b className="font-semibold">calidad humana y profesional</b>
                &nbsp;de nuestro equipo de entrenadores
                reconocidos como referentes en la región.
              </div>
            </li>
            <li className="flex flex-col space-y-4">
              <svg className="w-12 h-12" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 100 100" fill="none">
                <rect className="fill-current text-green-200" width="100" height="100" rx="25" ry="25" />
                <path className="fill-current text-green-400" d="M50.1184 54.29527L32.79666 65.3182C32.92952 65.85694 33 66.42024 33 67c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7c1.83997 0 3.51414.7099 4.76354 1.87076l15.84162-10.08103L31.0222 38.91685C29.8405 39.6055 28.46632 40 27 40c-4.41828 0-8-3.58172-8-8s3.58172-8 8-8 8 3.58172 8 8c0 1.49355-.40928 2.8915-1.1218 4.08782l15.30564 12.6438 11.06541-18.87628C58.86117 28.4942 58 26.59767 58 24.5c0-4.14214 3.35786-7.5 7.5-7.5 4.14214 0 7.5 3.35786 7.5 7.5 0 4.14214-3.35786 7.5-7.5 7.5-.6029 0-1.18917-.07114-1.7509-.20547L52.4865 51.00719l18.79552 9.39775C72.7343 58.92095 74.7596 58 77 58c4.41828 0 8 3.58172 8 8s-3.58172 8-8 8-8-3.58172-8-8c0-.73457.099-1.44602.2844-2.12173l-19.166-9.583zM50 83c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6 6 2.6863 6 6-2.6863 6-6 6z" />
                <circle className="fill-current text-white" cx="50" cy="50" r="13" />
              </svg>
              <div className="text-lg">
                Por nuestra&nbsp;
                <b className="font-semibold">contribución a la comunidad</b>
                &nbsp;hispanohablante.
              </div>
            </li>
          </ul>
        </Container>
      </div>
      <div className="flex justify-center relative -mx-32 md:mx-0 lg:-mt-20 lg:-mb-20 lg:-mr-20 select-none">
        <Image
          src="nosotros/acerca-de-aibes-bottom.jpg"
          className="max-w-full h-auto w-5/6 mx-auto select-none pointer-events-none"
          alt="Acerca de AIBES"
        />
      </div>
      <div className="relative pb-10 lg:pb-20">
        <Container className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 relative z-30">
          <div className="lg:col-span-6">
            <Card icon="users" link="/entrenadores">
              <CardTitle>
                Nuestros entrenadores
              </CardTitle>
              <CardText>
                Están preparados para enseñar y acompañar a los equipos en el
                dominio de las técnicas y herramientas que los conducirán al
                desarrollo ágil de productos.
              </CardText>
            </Card>
          </div>
          <div className="lg:col-span-6">
            <Card icon="envelope" link="/contacto">
              <CardTitle>
                Mantengamos el contacto
              </CardTitle>
              <CardText>
                Estamos aquí para ayudarle en sus procesos de adopción ágil y
                responder sus preguntas por chat, correo electrónico o llamada
                telefónica.
              </CardText>
            </Card>
          </div>
        </Container>
        <div className="absolute inset-0 bg-gray-100 transform lg:mt-10 -skew-y-6 shadow-outside-light-xl" style={{ height: '200%' }} />
      </div>
    </div>
  );
}
